import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ContactView from "../views/ContactView.vue";
import NieuwsView from "../views/NieuwsView.vue";
import OrganisatieView from "@/views/OrganisatieView.vue";
import OverOns from "@/views/OverOns.vue";
import AdminView from "@/views/Admin/AdminView.vue";
import AdminNieuws from "@/views/Admin/AdminNieuws.vue";
import EditNieuws from "@/views/Admin/EditNieuws.vue";
import AdminNieuwsBrief from "@/views/Admin/AdminNieuwsBrief.vue";
import NieuwsArtikel from "@/views/NieuwsArtikel.vue";
import SteunOns from "@/views/SteunOns.vue";
import AdminDonaties from "@/views/Admin/AdminDonaties.vue";
import AdminReviews from "@/views/Admin/AdminReviews.vue";
import FaqView from "@/views/FaqView.vue";
const routes = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
  },
  {
    path: "/nieuws",
    name: "Nieuws",
    component: NieuwsView,
  },
  {
    path: "/nieuws/:id",
    name: "Nieuws - Artikel",
    component: NieuwsArtikel,
  },
  {
    path: "/organisatie",
    name: "Organisatie",
    component: OrganisatieView,
  },
  {
    path: "/overons",
    name: "Over ons",
    component: OverOns,
  },
  {
    path: "/veelgestelde-vragen",
    redirect: "/veelgestelde-vragen/gezinnen",
  },
  {
    path: "/veelgestelde-vragen/:doelgroep(gezinnen|ziekenhuizen|partners-en-vrienden)",
    name: "Veelgestelde vragen",
    component: FaqView,
    props: true,
  },
  {
    path: "/contact",
    name: "Contact",
    component: ContactView,
  },
  {
    path: "/steunons",
    name: "Steun ons",
    component: SteunOns,
  },
  {
    path: "/admin",
    name: "Admin",
    component: AdminView,
    redirect: "/admin/nieuws",
    children: [
      {
        path: "/admin/nieuws",
        name: "Admin Nieuws",
        component: AdminNieuws,
      },
      {
        path: "/admin/edit/:id",
        name: "Admin Nieuws Aanpassen",
        component: EditNieuws,
      },
      {
        path: "/admin/nieuwsbrief",
        name: "Admin Nieuwsbrief",
        component: AdminNieuwsBrief,
      },
      {
        path: "/admin/donaties",
        name: "Admin Donaties",
        component: AdminDonaties,
      },
      {
        path: "/admin/reviews",
        name: "Admin Reviews",
        component: AdminReviews,
      },
    ],
  },
];

// Oude ankers blijven werken nadat een sectie is hernoemd.
const legacyHashes = {
  "#sponsoren": "#partners",
};

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    return new Promise((resolve) => {
      const hash = legacyHashes[to.hash] || to.hash;
      if (hash) {
        setTimeout(() => {
          resolve({
            el: hash,
            behavior: "smooth",
          });
        }, 150);
      } else {
        resolve({ top: 0 });
      }
    });
  },
});
//
export default router;
